//Hooks
import { useHomeFetch } from "../hooks/useHomeFetch";
//config
import { POSTER_SIZE, BACKDROP_SIZE, IMAGE_BASE_URL } from "../config";
//components
import HeroImage from "./HeroImage/Hero";
import Grid from "./Grid/Grid";
import Thumbnail from "./Thumb/Thumbnail";
import Spinner from "./Spinner/Spinner";
import SearchBar from "./SearchBar/SearchBar";
import Button from "./Button/Button";
//Image
import noImg from "../images/no_image.jpg";

const Home = () => {
  const { state, loading, error, setSearchTerm, searchTerm, setIsLoadingMore } = useHomeFetch();

  console.log(state);

  if (error) return <div>OOPS! SOMETHING WENT WRONG</div>

  return (
    <>
      {state.results[0] && (
        <HeroImage
          image={`${IMAGE_BASE_URL}${BACKDROP_SIZE}${state.results[0].backdrop_path}`}
          title={state.results[0].original_title}
          text={state.results[0].overview}
        />
      )}
      <SearchBar setSearchTerm={setSearchTerm}/>

      <Grid header={!searchTerm ? "Mavic's Popular Movies" : "Search Results"}>
        {state.results.map((movie) => (
          <Thumbnail
            key={movie.id}
            clickable
            image={
              movie.poster_path
                ? IMAGE_BASE_URL + POSTER_SIZE + movie.poster_path
                : noImg
            }
            movieId={movie.id}
          />
        ))}
      </Grid>
      {loading && <Spinner />}
      {state.page < state.total_pages && !loading && (<Button text="Load More" callback={() => setIsLoadingMore(true)}/>)}
    </>
  );
};

export default Home;
